<template>
  <div id="mod7">
    <PopupModal ref="mod7EditNewBusinessForm" :P_largeModal="true" :P_showClose="true" @close-modal="closeSelf">
    
      <!-- Title -->
      <div slot="title"> 
        <h3  class="font-bold"></h3>
      </div>
      
      <!-- Body -->
      <template slot="body">
        <div class="pb-10">
          <c9EditNewBusinessForm
            @newBusiness="closeSelf"
            :P_businessFormType="P_viewType"
            :P_showHeader="findLastIndex"
            :P_businessUid="P_businessUid"
            @event-back="closeSelf"
          />
        </div>

      </template>
    </PopupModal>
  </div>
</template>

<script>
import moment from 'moment';
import PopupModal from './PopupModal.vue';
import c9EditNewBusinessForm from "../c1/c9EditNewBusinessForm.vue"

export default {
  name: "mod7EditNewBusinessForm",

  props: ['P_businessUid', 'P_viewType'],

  components: {PopupModal, c9EditNewBusinessForm },

  data() {
    return {
      DV_ccIndexes: window.G_bi2_data.IV_al_consumer_contact_index,
      DV_consumerContact: null,
      DV_conversationInfo: null,
      DV_consumerConversationUuid: "",
      moment: moment,
      DV_showModal: false,
    };
  },

  mounted() {
    // 
  },
  watch:{
    // 
  },

  methods: {
    showSelf() {
      this.DV_showModal = true;
      this.$refs.mod7EditNewBusinessForm.show();        
    },

    closeSelf() {
      this.$refs.mod7EditNewBusinessForm.hide();
      this.DV_showModal = false;
    },
    
    findLastIndex() {
      // 
    }
  },
};
</script>
